import { AppComponent } from "./../../../app.component";
import { Component, OnInit, Output, EventEmitter } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from 'src/environments/environment';
import { AuthService } from "src/app/services/auth/auth.service";
import { GlobalVariables } from "../../utils/global-variables.service";
import { ConfigService } from "../../services/config/config-service";

@Component({
  selector: "app-header",
  templateUrl: "./header.component.html",
  styleUrls: ["./header.component.css"],
})
export class HeaderComponent implements OnInit {
  isLoggedIn$: Observable<boolean>;
  ambiente: String;
  envName: String;
  @Output("sideNav") sideNav: EventEmitter<boolean> = new EventEmitter();

  constructor(
    private authService: AuthService,
    public globalVariables: GlobalVariables,
    public RightSidenavComponent: AppComponent,
    public configService: ConfigService
  ) {}

  ngOnInit() {
    this.ambiente = this.configService.getEnvProp("nome");
    this.envName = environment.envName;
  }

  onLogout() {
    this.authService.logout();
  }

  public get name() {
    return this.authService.getLoggedUserName();
  }

  public get userId()
  {
    return this.authService.getLoggedUserId();
  }

  public get userRowid()
  {
    return this.authService.getLoggedUserRowid();
  }

  toggleSidenav() {
    this.sideNav.emit();
  }
}
